import saga from './saga';
import reducer from './reducer';

export default {
  saga,
  reducer
};
